(function(angular){
	'use strict';
	
	angular
		.module('urlModule')
		.factory('InvestmentEntityFactory', [
			'$q',
			'INVESTMENT_ENTITY_ID',
			'urlFactory',
			InvestmentEntityFactoryFunction
		]);
	
	function InvestmentEntityFactoryFunction(
		$q,
		INVESTMENT_ENTITY_ID,
		urlFactory
	) {
		var newsFeedNextPage;

		var factory = {
			newsfeed: {
				getFirstPage: getNewsFeedFirstPage,
				getNextPage: getNewsFeedNextPage
			},
			getEntityOverview: getEntityOverview,
			getPerformanceData: getPerformanceData,
			getPaymentMethodOptions: getPaymentMethodOptions,
			linkManualBankAccount: linkManualBankAccount,
			upgradeToRia: upgradeToRia
		};
		
		return factory;

		function getEntityOverview() {
			var deferred = $q.defer();
			var url = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID;

			urlFactory.apiGetPromise(url)
				.then(function(response) {
					deferred.resolve(response.data);
				})
				.catch(function(response) {
					deferred.reject(response);
				});

			return deferred.promise;			
		}

		function getNewsFeedFirstPage(filters) {
			var url = urlFactory.serializeParamsAndCreateUrl(
				'/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/news-feed/page', 
				filters
			);

			return urlFactory.apiGetPromise(url)
				.then(function(response) {
					newsFeedNextPage = response.data.meta.nextPage;
					return response.data;
				});
		}

		function getNewsFeedNextPage() {
			if(angular.isDefined(newsFeedNextPage)) {
				return urlFactory.apiGetPromise(newsFeedNextPage.pageUrl)
					.then(function(response) {
						newsFeedNextPage = response.data.meta.nextPage;
						return response.data;
					});
			} else {
				return $q.reject();
			}
		}

		function getPerformanceData() {
			var performanceUrl = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/performance';

			return urlFactory.apiGetPromise(performanceUrl)
				.then(function(response) {
					return response.data;
				});
		}

		function formatPaymentMethodAccountTypeLabels(data){
			angular.forEach(data, function(paymentMethod){
				var formattedAccountType = paymentMethod.accountType.charAt(0).toUpperCase() + paymentMethod.accountType.slice(1).toLowerCase();
				paymentMethod.label = paymentMethod.label + " (" + formattedAccountType + ")";
			});
		}

		function getPaymentMethodOptions(options){
			var bankAccountUrl = "/api-secured/investment-entity/" + INVESTMENT_ENTITY_ID + "/bank-accounts";

			return urlFactory.apiGetPromise(bankAccountUrl)
				.then(function(response) {
					formatPaymentMethodAccountTypeLabels(response.data);

					if(angular.isDefined(options)) {
						if(options.includePlaid) {
							response.data.push({
								id: "-1",
								label: "New bank account",
								primaryAccount: false
							});
						}
						
						if(options.includeWire) {
							response.data.push({
								id: "-2",
								label: "Wire Transfer",
								primaryAccount: false,
								isWireTransfer: true
							});
						}
					}

					return response.data;
				});
		}

		function linkManualBankAccount(data, form){
			var url = "/api-secured/investment-entity/" + INVESTMENT_ENTITY_ID + "/link-manual-bank-account";
			return urlFactory.apiPostPromise(url, data)
				.then(function(response){
					return response.data;
				})
				.catch(function(response){
					urlFactory.handleServerValidation(form, response);
					return $q.reject();
				});
		}

		function upgradeToRia(payload){
			var url = "/api-secured/investment-entity/" + INVESTMENT_ENTITY_ID + "/ria/upgrade";
			return urlFactory.apiPostPromise(url, payload)
				.then(function(response){
					return response.data;
				})
				.catch(function(response){
					urlFactory.handleFailedRequest(response);
					return $q.reject(response);
				});
		}
	}
})(window.angular);